import React, { useEffect, useState } from "react";
import { FirebaseContext } from "../../context/firebase";
import * as PROJECT_CODE from "../../constants/projectCode";
import styles from "./JoinAppointment.module.scss";
import JoinShortCode from "../agenda/joinFromCode/JoinShortCode";

const JoinAppointment = () => {
  return (
    <div className={styles.join_appointment_page}>
      <h2 className={styles.join_appointment_title}>Join Appointment</h2>
      <div>
        <JoinShortCode />
      </div>
    </div>
  );
};

export default JoinAppointment;
